// 3rd party libs
import React from 'react';

// local modules
import PeopleIcon from '../../../assets/icons/people.svg';
import styles from './PeopleCount.module.scss';

type TPeopleCount = {
  count: number;
  limit?: number;
};

const PeopleCount: React.FC<TPeopleCount> = ({ count, limit }) => {
  return (
    <>
      <img className={styles.img} src={PeopleIcon} alt="people count" />
      <span>
        {count}
        {limit && `/${limit}`}
      </span>
      </>
  );
};

export default PeopleCount;
